import { ReactElement } from "react";
import PaginaLegal, { PaginaLegalProps } from "./componentes/PaginaLegal";
import { ANCORAS_LEGAIS } from "./componentes/Legal/secoes";

interface RotaLegalPublica {
  /** Documento para onde rolar ao abrir; null abre no topo, no índice. */
  ancoraInicial: string | null;
}

// Páginas abertas do painel: renderizam antes de qualquer checagem de login.
// As duas caem na mesma página (índice + os dois textos em sequência) e mudam
// só o ponto de entrada — App Store e Play pedem uma URL para cada documento.
// O nginx do admin.sauhde.com.br já faz `try_files $uri /index.html`, então
// qualquer caminho listado aqui carrega o SPA e cai neste resolvedor.
const ROTAS_PUBLICAS: Record<string, RotaLegalPublica> = {
  "/privacidade": { ancoraInicial: ANCORAS_LEGAIS.privacidade },
  "/termos": { ancoraInicial: ANCORAS_LEGAIS.termos },
};

const normalizarCaminho = (caminho: string): string => {
  const semBarraFinal = caminho.replace(/\/+$/, "");
  return (semBarraFinal || "/").toLowerCase();
};

/**
 * Resolve o pathname atual em uma página pública; devolve null quando o caminho
 * pertence ao painel autenticado.
 *
 * resolverRotaPublica("/privacidade") // => <PaginaLegal ... />
 */
export const resolverRotaPublica = (
  caminho: string,
): ReactElement<PaginaLegalProps> | null => {
  const rota = ROTAS_PUBLICAS[normalizarCaminho(caminho)];
  if (!rota) return null;

  return <PaginaLegal ancoraInicial={rota.ancoraInicial} />;
};
